module.exports = __webpack_public_path__ + "static/media/win_points_iupp.73042810.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/win_points_iupp.png
// module id = 1908
// module chunks = 19